// extracted by mini-css-extract-plugin
export default {"presetsBlock":"Preset_presetsBlock__ggdo2","presetGrid":"Preset_presetGrid__Y5l8k","blockSlider":"Preset_blockSlider__ODRWJ"};